// src/actions/types.js
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';

export const UPDATE_LAND_FOR_SALE_FORM = 'UPDATE_LAND_FOR_SALE_FORM';
export const SUBMIT_LAND_FOR_SALE_FORM = 'SUBMIT_LAND_FOR_SALE_FORM';
export const RESET_LAND_FOR_SALE_FORM = 'RESET_LAND_FOR_SALE_FORM';

export const UPDATE_PROFILE_FORM = 'UPDATE_PROFILE_FORM';
export const UPDATE_FILL_FORM = 'UPDATE_FILL_FORM';
